module.exports = __webpack_public_path__ + "static/media/strawberry.2bdd02fe.png";